import PageRenderer from "../components/PageRenderer";

const Impressum = () => <PageRenderer pageName="Impressum" analyticsPath="/impressum" />;

export default Impressum;
